var map = {
	"./views/deck/src/_view.js": [
		1,
		4
	],
	"./views/deck/src/analytics.js": [
		14,
		5
	],
	"./views/game/src/_view.js": [
		2,
		6
	],
	"./views/game/src/analytics.js": [
		17,
		7
	],
	"./views/main/src/_view.js": [
		3,
		8
	],
	"./views/main/src/game.js": [
		18,
		2,
		9
	],
	"./views/main/src/index.js": [
		19,
		3,
		10
	],
	"./views/main/src/stats.js": [
		20,
		11
	],
	"./views/profile/src/_view.js": [
		4,
		12
	],
	"./views/profile/src/settings.js": [
		21,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 13;
module.exports = webpackAsyncContext;